/**
 * Shopify URL Parameter Cleaner
 * Removes unwanted search and tracking parameters from URLs
 * without affecting site functionality
 */

(function() {
    'use strict';
    
    // Define unwanted parameters to remove
    const unwantedParams = [
        '_pos',     // Search result position
        '_sid',     // Session ID
        '_ss',      // Search session reference
        '_v',       // Version parameter (sometimes appears)
        'sort_by',  // Optional: remove if you don't want sorting to show in URL
        'q'         // Optional: remove search query from URL (uncomment if desired)
    ];
    
    // Optional: Add more parameters you want to remove
    // const additionalParams = ['utm_source', 'utm_medium', 'utm_campaign'];
    // unwantedParams.push(...additionalParams);
    
    /**
     * Clean URL parameters
     */
    function cleanUrlParameters() {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || !window.location) {
            return;
        }
        
        try {
            const currentUrl = new URL(window.location.href);
            let hasChanges = false;
            
            // Remove unwanted parameters
            unwantedParams.forEach(param => {
                if (currentUrl.searchParams.has(param)) {
                    currentUrl.searchParams.delete(param);
                    hasChanges = true;
                }
            });
            
            // Update URL if changes were made
            if (hasChanges) {
                const newUrl = currentUrl.toString();
                
                // Use replaceState to update URL without page reload
                if (window.history && window.history.replaceState) {
                    window.history.replaceState(
                        window.history.state, 
                        document.title, 
                        newUrl
                    );
                    
                    // Optional: Log the cleanup (remove in production)
                    console.log('URL cleaned:', newUrl);
                }
            }
            
        } catch (error) {
            // Silently handle any URL parsing errors
            console.warn('URL parameter cleanup failed:', error);
        }
    }
    
    /**
     * Initialize the cleaner
     */
    function init() {
        // Clean URL on initial page load
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', cleanUrlParameters);
        } else {
            cleanUrlParameters();
        }
        
        // Optional: Clean URL when navigating (for single-page app behavior)
        window.addEventListener('popstate', cleanUrlParameters);
        
        // Optional: Clean URL periodically (uncomment if needed)
        // setInterval(cleanUrlParameters, 5000); // Every 5 seconds
    }
    
    // Start the cleaner
    init();
    
    // Optional: Expose function globally for manual use
    window.cleanShopifyUrl = cleanUrlParameters;
    
})();